<template>
	<div
		v-if="orders.length"
		class="last-orders"
	>
		<h2
			class="last-orders__title"
			v-html="$t('shoplist.lastOrders.title')"
		/>
		<ul
			class="last-orders__list"
		>
			<LastOrdersItem
				v-for="order in orders"
				:key="order.tokenValue"
				:order="order"
				@click="$emit('click', order.tokenValue)"
			/>
		</ul>
	</div>
</template>

<script>
import LastOrdersItem from '@/components/LastOrdersItem';

export default {
	components: {
		LastOrdersItem,
	},
	props: {
		orders: Array
	}
}
</script>
